import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */


var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Context } from './injectIntl';
import { formatMessage } from '../formatters/message';
import { invariantIntlContext, DEFAULT_INTL_CONFIG, createFormatters } from '../utils';
import * as shallowEquals_ from 'shallow-equal/objects';
var shallowEquals = shallowEquals_["default"] || shallowEquals_;

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }

  return formatMessage(Object.assign(Object.assign({}, DEFAULT_INTL_CONFIG), {
    locale: 'en'
  }), createFormatters(), descriptor, values);
};

var FormattedMessage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FormattedMessage, _React$Component);

  function FormattedMessage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormattedMessage.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _a = this.props,
        values = _a.values,
        otherProps = __rest(_a, ["values"]);

    var nextValues = nextProps.values,
        nextOtherProps = __rest(nextProps, ["values"]);

    return !shallowEquals(nextValues, values) || !shallowEquals(otherProps, nextOtherProps);
  };

  _proto.render = function render() {
    var _this = this;

    return React.createElement(Context.Consumer, null, function (intl) {
      if (!_this.props.defaultMessage) {
        invariantIntlContext(intl);
      }

      var _ref = intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage = _ref$formatMessage === void 0 ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === void 0 ? React.Fragment : _ref$textComponent;

      var _this$props = _this.props,
          id = _this$props.id,
          description = _this$props.description,
          defaultMessage = _this$props.defaultMessage,
          values = _this$props.values,
          children = _this$props.children,
          _this$props$tagName = _this$props.tagName,
          Component = _this$props$tagName === void 0 ? Text : _this$props$tagName;
      var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
      };
      var nodes = formatMessage(descriptor, values);

      if (!Array.isArray(nodes)) {
        nodes = [nodes];
      }

      if (typeof children === 'function') {
        return children.apply(void 0, _toConsumableArray(nodes));
      }

      if (Component) {
        // Needs to use `createElement()` instead of JSX, otherwise React will
        // warn about a missing `key` prop with rich-text message formatting.
        return React.createElement.apply(React, [Component, null].concat(_toConsumableArray(nodes)));
      }

      return nodes;
    });
  };

  return FormattedMessage;
}(React.Component);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.defaultProps = {
  values: {}
};
export default FormattedMessage;